import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable()
export class ThemeHelpersService {

    private listeners = new Subject<any>();

    constructor() { }

    /**
     * Listens to custom listeners
     */
    listen(): Observable<any> {
        return this.listeners.asObservable();
    }

    /**
     * Updates the custom set of listeners with new data.
     * @param {string} type - the listener identifier or ID
     * @param {any} data - The listener data to broadcast.
     */
    updateListener(type: string, data: any = {}) {
        this.listeners.next([type, data]);
    }

    /**
     * Check the value exists, not null, not undefined and not empty. returns true/false
     * @param value - value to check
     */
    valCheck(value) {
        if (value === null || value === '' || value === undefined) {
            return false;
        } else {
            return true;
        }
    }

    /**
     * Converts a file or blob to base 64
     * @param {blob} blob - file or blob
     * @param callback - returns a base64 string of the supplied blob or data.
     */
    blobToBase64(blob: Blob, callback) {
        const reader = new FileReader();
        let base64data;
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
            base64data = reader.result;
            callback(base64data);
        };
    }

    blobToByteArray(blob: Blob, callback) {
        const reader = new FileReader();
        let byets;
        reader.readAsArrayBuffer(blob);
        reader.onload = () => {
            byets = reader.result;
            callback(byets);
        };
    }

    convertToSeconds(time) {
        const a = time.split(':');
        return (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
    }

    /**
     * Performs alpha numeric sorting
     * @param {array} list - the list to sort
     * @param {string} sortKey  - the key to sort by
     * @returns
     */
    alphaNumericSorting(list: any[], sortKey: string) {
        if (!list && !sortKey) {
            return list;
        }
        const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
        return list.sort((a, b) => {
            return collator.compare(a[sortKey], b[sortKey]);
        });
    }
}
